import { GestaoAlertasService } from './../components/services/gestao-alertas.service';
import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Paginator } from '@core/models/paginator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalGestaoAlertasComponent } from '../components/modal-gestao-alertas/modal-gestao-alertas.component';
import { AlertaForm, LocalExibicaoAlertas, ModoExibicaoAlertas, StatusAlertas, TipoAlertaEnum, TipoAlertas } from '../models/alerta';
import { Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { ExcluirInativarAlertaDialogComponent } from '../components/excluir-inativar-alerta-dialog/excluir-inativar-alerta-dialog.component';
import { NotificationService } from '@core/services/notification.service';


@Component({
  selector: 'app-gestao-alertas',
  templateUrl: './gestao-alertas.component.html',
  styleUrls: ['./gestao-alertas.component.scss']
})
export class GestaoAlertasComponent implements OnInit {
  displayedAlertaColumns: string[] = ['select', 'alertTitle', 'products', 'alertType', 'alertStart', 'alertEnd', 'alertActive', 'acoes'];
  dataSource = new MatTableDataSource<AlertaForm>();
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  pageSizeOptions = [5, 10, 20, 50, 100];
  pageSize: any;
  newPaginator: Paginator = new Paginator;
  page: number = 1;

  alertasFiltroForm: FormGroup;
  tiposAlertas: TipoAlertas[];
  locaisExibicaoAlertas: LocalExibicaoAlertas[] = [];
  statusAlertas: StatusAlertas[] = [];
  modosExibicaoAlertas: ModoExibicaoAlertas[] = [];
  tiposAlertasEnum = TipoAlertaEnum;
  rotas: string[] = [];
  selectionAlertas = new SelectionModel<any>(true, []);
  produtosPortal: any[] = [];
  rotasAlertas: any[] = [];
  productName: any;

  buttonLabelAcoes = 'Ações em massa';
  buttonIconAcoes = 'uil uil-list-ul';
  headerTitleAcoes = 'Ações em massa';
  headerIconAcoes = 'uil uil-list-ul';
  dropdownItemsAcoes = [
    { label: 'Inativar', icon: 'uil uil-toggle-off' },
    { label: 'Ativar', icon: 'uil uil-toggle-on' }
  ]

  clearDateInputEvent = new EventEmitter<boolean>();
  validateInputEvent = new EventEmitter<boolean>();

  constructor(private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private gestaoAlertasService: GestaoAlertasService,
    private router: Router,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.alertasFiltroForm = this.formBuilder.group({
      title: [''],
      products: [null],
      alertType: [null],
      alertStart: [null],
      alertEnd: [null],
      active: [null],
      routes: [null]
    });
    this.getFields();
    this.getTamanhoTela();
    this.filter();
  }

  getFields() {
    this.gestaoAlertasService.getTiposAlertas().subscribe(tipos => this.tiposAlertas = tipos);
    this.gestaoAlertasService.getModosExibicao().subscribe(modos => this.modosExibicaoAlertas = modos);
    this.gestaoAlertasService.getStatusAlertas().subscribe(status => this.statusAlertas = status);
    this.rotasAlertas = this.router.config.filter(
      route =>
        route.path &&
        !route.path.includes('/:')
    );
  }

  getNomesProdutos(element: any) {
    const products = element.products?.map(p => p.name).filter(Boolean).join(', ') || '';
    const routes = element.routes.join(', ') || '';

    return [products, routes].filter(Boolean).join(', ');
  }

  ordenar(sort: Sort) {

    let ordenacao = {
      order: sort.direction,
      orderBy: sort.active
    }
    this.resetPaginator();
    this.filter(null, ordenacao);
  }

  filter(lastPage?, ordenacao?) {
    if (lastPage && lastPage == this.newPaginator.pagina)
      return;
    this.newPaginator.lastPage = this.newPaginator.pagina;
    let validDate = this.validateDate();
    if(validDate){
      const filtro = {
        ...this.alertasFiltroForm.value, ...this.newPaginator.toBody(), ...ordenacao
      }
      this.gestaoAlertasService.listarAlertas(filtro).subscribe((data) => {
        this.dataSource.data = data.content;
        this.dataSource.paginator = null;
        this.newPaginator.collectionSize = data.totalElements;
        this.selectionAlertas.clear();
      }, (error) => {
        console.log(error)
      })
    }else{
      this.notificationService.info('A data de início deve ser menor ou igual a data fim')
    }
  }

  
validateDate(): boolean {
  const initialDate = new Date(this.dataInicio);
  const finalDate = new Date(this.dataFim);

  return finalDate >= initialDate;
}


  deleteAlert(element) {
    this.gestaoAlertasService.excluirAlerta(element.id).subscribe()
  }

  alertaClass(element) {
    switch (element.alertType) {
      case TipoAlertaEnum.Alerta:
        return 'status-progress'
        break;
      case TipoAlertaEnum.Informacao:
        return 'status-progress-process'
        break;
      case TipoAlertaEnum.Sucesso:
        return 'status-progress-sucess'
        break;
      case TipoAlertaEnum.Erro:
        return 'status-progress-error'
        break;
    }
  }

  getElementStatusColor(element) {
    if (element.active == true) {
      return { 'color': '#00A955' }
    }
    else {
      return { 'color': '#E93314' }
    }
  }

  activeInactiveAlert(element) {
    this.gestaoAlertasService.ativarInativarAlerta(element.id, !element.active).subscribe(() => this.filter())
  }

  activeMultipleAlerts() {
    let alertsSelected = this.selectionAlertas.selected
    if (alertsSelected.some(x => x.active == true)) {
      this.notificationService.info('Há alertas selecionados com status diferente de INATIVO')
    } else {
      const data = alertsSelected.map(alerta => ({
        id: alerta.id,
        active: !alerta.active
      }));

      this.gestaoAlertasService.ativarInativarAlertasMultiplos(data).subscribe(retorno => {
        this.notificationService.success("Alertas ativados com sucesso!");
        this.filter();
      }),
        err => this.notificationService.error("Não foi possível ativar alertas!")
    }
  }

  inactiveMultipleAlerts() {
    let alertsSelected = this.selectionAlertas.selected;
    if (alertsSelected.some(x => x.active == false)) {
      this.notificationService.info('Há alertas selecionados com status diferente de ATIVO')
    } else {
      const data = alertsSelected.map(alerta => ({
        id: alerta.id,
        active: !alerta.active
      }));

      this.gestaoAlertasService.ativarInativarAlertasMultiplos(data).subscribe(retorno => {
        this.notificationService.success("Alertas inativados com sucesso!");
        this.filter();
      }),
        err => this.notificationService.error("Não foi possível inativar alertas!")
    }
  }


  handleSubmit(event: any) {
    if (event.label == 'Ativar') {
      this.activeMultipleAlerts()
    }
    if (event.label == 'Inativar') { }
    this.inactiveMultipleAlerts()
  }

  showToggleChecked(element) {
    return element.active == true ? true : false;
  }

  clearFields() {
    this.alertasFiltroForm.reset();;
  }

  openModalAlert(acao: string, element?: any) {
    let component = this.modalService.open(ModalGestaoAlertasComponent, {
      keyboard: false,
      centered: true,
      windowClass: 'modal-gestao-alertas',
      backdropClass: 'modal-backdrop-formulario',
      scrollable: true,
    });
    let instance = <ModalGestaoAlertasComponent>component.componentInstance;
    instance.acao = acao;
    element ? instance.element = element : null;

    component.result.then((data) => {
      if (data) {
        this.filter();
      }
      this.filter();
    })
  }

  openConfirmDialog(acao: string, element: any) {
    let excluirAtivarInativarAlerta = this.modalService.open(ExcluirInativarAlertaDialogComponent, {
      keyboard: false,
      centered: true,
      backdropClass: 'modal-back-drop-z-index-1050',
      windowClass: 'modal-alert',
      scrollable: true,
      size: 'lg'
    })

    let instance = <any>excluirAtivarInativarAlerta.componentInstance;
    instance.alerta = element;
    instance.acaoType = acao
    excluirAtivarInativarAlerta.result.then((data) => {
      if (data) {
        this.filter();
      }
      this.filter();
    })
  }

  isAllSelected() {
    const numSelected = this.selectionAlertas.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selectionAlertas.clear() :
      this.dataSource.data.forEach(row => this.selectionAlertas.select(row));
  }

  compareFn(a, b) {
    return a == b;
  }

  getStatusById(element) {
    return element.active == true ? 'Ativo' : 'Inativo'
  }

  resetPaginator(): void {
    this.newPaginator.lastPage = 0;
    this.newPaginator.collectionSize = 0;
  }

  trocarSize(event): void {
    this.newPaginator.pagina = 1;
    this.newPaginator.lastPage = 0;
    this.newPaginator.registros = event;
    this.filter();
  }

  getTamanhoTela() {
    const tamanhoTela = window.innerWidth;
    return tamanhoTela <= 1966;
  }

  get dataInicio(){
    return this.alertasFiltroForm.controls.alertStart.value
  }

  get dataFim(){
    return this.alertasFiltroForm.controls.alertEnd.value
  }
}
